import { StateType } from '../../index';
import { createSelector } from 'reselect';
import { CompetitionImmutable } from '../../../components/Competitions/CompetitionsTypes';
import { filterNewCompetitions } from '../../CompetitionsReducer/CompetitionsSelector';
import Immutable from 'immutable';

export const dashboardCompetitionsLevelsOptionsSelector = (state: StateType) => state.getIn(['dashboard', 'competitions', 'levelsOptions']);
export const dashboardCompetitionsDataSelector = (state: StateType) =>
  state.getIn(['dashboard', 'competitions', 'data']) as Immutable.List<CompetitionImmutable>;
export const dashboardLatestCompetitionsDataSelector = createSelector(dashboardCompetitionsDataSelector, filterNewCompetitions);
export const dashboardCompetitionsIsFetchingSelector = (state: StateType) => state.getIn(['dashboard', 'competitions', 'isFetching']);
